import { initReactI18next } from "react-i18next";
import i18next from "i18next";
import en from "@/i18n/locales/en/index.js";
import ru from "@/i18n/locales/ru/index.js";

i18next.use(initReactI18next).init({
  lng: "ru",
  fallbackLng: "ru",
  resources: {
    en,
    ru,
  },
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
